/* Blackheath Stamps — /learn pages: FAQ accordion (FAQPage-friendly). */
(function () {
  "use strict";
  document.querySelectorAll(".bhs-faqs__q").forEach(function (q) {
    q.addEventListener("click", function () {
      var open = q.getAttribute("aria-expanded") === "true";
      q.setAttribute("aria-expanded", String(!open));
      var panel = document.getElementById(q.getAttribute("aria-controls"));
      if (panel) panel.hidden = open;
    });
  });

  /* Glossary: live search + category filter */
  var glist = document.getElementById("bhs-glist");
  if (glist) {
    var entries = Array.prototype.slice.call(glist.querySelectorAll(".bhs-gentry"));
    var letters = Array.prototype.slice.call(glist.querySelectorAll("[data-letterhead]"));
    var search = document.getElementById("bhs-gsearch");
    var chips = Array.prototype.slice.call(document.querySelectorAll(".bhs-gchip"));
    var noresult = document.querySelector(".bhs-gnoresult");
    var azlinks = Array.prototype.slice.call(document.querySelectorAll(".bhs-azbar a"));
    var activeCat = "all";

    function apply() {
      var q = (search && search.value || "").trim().toLowerCase();
      var shown = 0;
      entries.forEach(function (en) {
        var okText = !q || (en.getAttribute("data-search") || "").indexOf(q) !== -1;
        var okCat = activeCat === "all" || (en.getAttribute("data-cat") || "") === activeCat;
        var vis = okText && okCat;
        en.hidden = !vis;
        if (vis) shown++;
      });
      /* hide a letter heading when none of its entries are visible */
      letters.forEach(function (lt) {
        var anyVisible = false, n = lt.nextElementSibling;
        while (n && !n.hasAttribute("data-letterhead")) {
          if (n.classList.contains("bhs-gentry") && !n.hidden) { anyVisible = true; break; }
          n = n.nextElementSibling;
        }
        lt.hidden = !anyVisible;
      });
      if (noresult) noresult.hidden = shown !== 0;
    }

    if (search) search.addEventListener("input", apply);
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-active"); });
        chip.classList.add("is-active");
        activeCat = chip.getAttribute("data-cat") || "all";
        apply();
      });
    });
    /* smooth-scroll the A to Z bar */
    azlinks.forEach(function (a) {
      a.addEventListener("click", function (ev) {
        var id = a.getAttribute("href").slice(1);
        var target = document.getElementById(id);
        if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: "smooth", block: "start" }); }
      });
    });
  }
})();
